import { formatNumber, formatInteger } from './formatNumber/formatNumber'
import {
  formatCurrency, getCurrencySymbol, getCurrencyCode, getCurrencyPlaceholder,
} from '../currency'

export default {
  install(Vue) {
    Vue.filter('formatNumber', formatNumber)
    Vue.filter('formatInteger', formatInteger)
    Vue.filter('formatCurrency', formatCurrency)
    Object.defineProperty(Vue.prototype, '$currencySymbol', {
      get() { return getCurrencySymbol() },
    })
    Object.defineProperty(Vue.prototype, '$currencyCode', {
      get() { return getCurrencyCode() },
    })
    Object.defineProperty(Vue.prototype, '$currencyPlaceholder', {
      get() { return getCurrencyPlaceholder() },
    })
  },
}
